import { INSURANCE_WAIVER_FEE } from './pricing';

const APP_URL = process.env.REACT_APP_APP_URL || window.location.origin;

async function sendEmail(payload: object): Promise<void> {
  const res = await fetch('/api/send-email', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as any).error || 'Email send failed');
  }
}

export async function sendContractEmail(
  toEmail: string,
  clientName: string,
  eventDate: string,
  signingToken: string
): Promise<void> {
  const signingLink = `${APP_URL}/sign/${signingToken}`;
  await sendEmail({
    to: [toEmail],
    subject: `Your Nuno Productions Contract — ${eventDate}`,
    html: `
      <div style="font-family:sans-serif;max-width:600px;margin:0 auto;padding:24px;">
        <h2 style="color:#C9A84C;font-family:serif;">Nuno Productions LLC</h2>
        <p>Hi ${clientName},</p>
        <p>Your venue rental contract for <strong>${eventDate}</strong> is ready to sign.</p>
        <p>
          <a href="${signingLink}" style="display:inline-block;background:#C9A84C;color:#fff;padding:12px 24px;border-radius:6px;text-decoration:none;font-weight:600;">
            Review &amp; Sign Contract
          </a>
        </p>
        <p style="color:#888;font-size:13px;">Or copy this link: <a href="${signingLink}">${signingLink}</a></p>
        <hr style="border:none;border-top:1px solid #eee;margin:24px 0;" />
        <p><strong>Before your event, make sure you have ready:</strong></p>
        <ul>
          <li>At least 1 portable restroom for your guests</li>
          <li>At least 1 security guard who is 21 or older</li>
          <li>Event insurance — get your own one-day liability policy naming Nuno Productions LLC as additional insured, OR send $${INSURANCE_WAIVER_FEE} via Zelle</li>
        </ul>
        <p>Questions? Reach out anytime.</p>
        <p>— Justin Nuno<br /><strong>Nuno Productions LLC</strong></p>
      </div>
    `,
  });
}

export async function sendChecklistEmail(
  toEmail: string,
  clientName: string,
  checklistToken: string
): Promise<void> {
  const checklistLink = `${APP_URL}/checklist/${checklistToken}`;
  await sendEmail({
    to: [toEmail],
    subject: 'Cleaning Checklist — Nuno Productions',
    html: `
      <div style="font-family:sans-serif;max-width:600px;margin:0 auto;padding:24px;">
        <h2 style="color:#C9A84C;font-family:serif;">Nuno Productions LLC</h2>
        <p>Hi ${clientName},</p>
        <p>Please complete the post-event cleaning checklist using the link below. All items must be completed before 11:59 PM the day after your event.</p>
        <p style="background:#fff3cd;border:1px solid #ffc107;padding:12px;border-radius:6px;">
          <strong>⚠️ Incomplete checklist = automatic $250 charge.</strong> Items will be verified — if they weren't completed, you will be charged regardless. Prefer to skip the checklist? You can pay the $250 cleaning fee directly instead.
        </p>
        <p>
          <a href="${checklistLink}" style="display:inline-block;background:#C9A84C;color:#fff;padding:12px 24px;border-radius:6px;text-decoration:none;font-weight:600;">
            Complete Checklist
          </a>
        </p>
        <p style="color:#888;font-size:13px;">Or copy this link: <a href="${checklistLink}">${checklistLink}</a></p>
        <p>— <strong>Nuno Productions LLC</strong></p>
      </div>
    `,
  });
}
